module.exports = __webpack_public_path__ + "static/media/more-details.f058c0e7.svg";